import React, { useEffect, useState } from "react";
import ApexCharts from "apexcharts";
import api from "../../../../api";

// Chart Component
const AvailableAssets = ({ month, year }) => {
  const [chartData, setChartData] = useState({ labels: [], data: [] });
  const [noData, setNoData] = useState(false); // Just to show message

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get('/avilable-assets', {
          params: { month, year }
        });

        if (response.data.data && response.data.data.length > 0) {
          setChartData({
            labels: response.data.labels,
            data: response.data.data,
          });
          setNoData(false);
        } else {
          setChartData({ labels: [], data: [] }); // Empty graph
          setNoData(true);
        }
      } catch (error) {
        console.error("Error fetching asset data:", error);
        setChartData({ labels: [], data: [] });
        setNoData(true);
      }
    };

    fetchData();
  }, [month, year]);

  useEffect(() => {
    const chartContainer = document.querySelector("#sf-only-bar");

    if (chartContainer) {
      const maxDataValue = Math.max(...chartData.data, 10);
      const maxYAxisValue = Math.ceil(maxDataValue / 100) * 100;

      const options = {
        series: [{ name: "Assets Quantity", data: chartData.data }],
        chart: {
          height: 265,
          type: "bar",
          fontFamily: "Plus Jakarta Sans, sans-serif",
          foreColor: "#adb0bb",
          toolbar: { show: false },
          stacked: true,
        },
        colors: ["#5D87FF"],
        plotOptions: {
          bar: {
            borderRadius: 6,
            columnWidth: "30%",
            borderRadiusApplication: "end",
          },
        },
        stroke: { show: false },
        dataLabels: { enabled: false },
        legend: { show: false },
        grid: { show: false },
        yaxis: {
          tickAmount: Math.floor(maxYAxisValue / 50),
          min: 0,
          max: maxYAxisValue,
          labels: {
            formatter: (val) => val.toFixed(0),
          },
        },
        xaxis: {
          categories: chartData.labels,
          axisTicks: { show: false },
        },
        tooltip: {
          theme: "dark",
          x: { show: false },
        },
      };

      const chart = new ApexCharts(chartContainer, options);
      chart.render();

      return () => chart.destroy();
    }
  }, [chartData]);

  return (
    <>
      <div id="sf-only-bar"></div>
      {noData && (
        <div className="text-center mt-3 fw-semibold text-muted">
          Data is Not Available
        </div>
      )}
    </>
  );
};


// Dropdown options
const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);

// Main Chart Card
const AssetsChartCard = () => {
  const [assetsFilters, setAssetsFilters] = useState({
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear()
  });

  return (
    <div className="card w-100 position-relative overflow-hidden">
      <div className="card-body">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h5 className="card-title mb-0 fw-semibold">Available Assets</h5>
          <div className="d-flex gap-2">
            <select
              className="form-select text-dark"
              value={assetsFilters.month}
              onChange={(e) => setAssetsFilters({
                ...assetsFilters,
                month: Number(e.target.value)
              })}
            >
              {months.map((m, i) => (
                <option key={i + 1} value={i + 1}>{m}</option>
              ))}
            </select>
            <select
              className="form-select text-dark"
              value={assetsFilters.year}
              onChange={(e) => setAssetsFilters({
                ...assetsFilters,
                year: Number(e.target.value)
              })}
            >
              {years.map((y) => (
                <option key={y} value={y}>{y}</option>
              ))}
            </select>
          </div>
        </div>

        <AvailableAssets 
          month={assetsFilters.month} 
          year={assetsFilters.year}
        />

        <div className="d-flex align-items-center justify-content-center">
          <span className="round-8 bg-primary rounded-circle me-2 d-inline-block"></span>
          <span>Assets Quantity</span>
        </div>
      </div>
    </div>
  );
};

export default AssetsChartCard;
